import PassengersScreenContent from './PassengersScreenContent';

export default PassengersScreenContent;
